import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MEMBERS_PER_PAGE } from '../../constants/pagination';
import { VIEW_MODE_SITE } from '../../constants/view-modes';
import clearMembers from '../../actions/clear-members';
import { fetchMembers, fetchMembersWithFakeLoading } from '../../actions/fetch-members';
import AccountSuspended from '../../components/account-suspended';
import AnimatedLoader from '../../components/animated-loader';
import DefaultDesktopLayout from '../../components/default-desktop-layout';
import EmptyStates from '../../components/empty-states';
import InfiniteListLoader from '../../components/infinite-list-loader';
import Loader from '../../components/loader';
import LoginButton from '../../components/login-button';
import MembersList from '../../components/member-list';
import MembersPlaceholder from '../../components/members-placeholder';
import NoMemberResults from '../../components/no-member-results';
import Page from '../../components/page';
import AppLoaded from '../../components/app-loaded';
import { replace } from '../../services/router-utils';
import { getIsMembersLoading } from '../../selectors/is-loading-selectors';
import { getMembers, getMembersCount } from '../../selectors/member-selectors';
import { getViewMode } from '../../selectors/view-mode-selectors';
import withAuth from '../../hoc/with-auth';
import withTranslate from '../../hoc/with-translate';

const reset = () => ({ page: 1 });
const increment = state => ({ page: state.page + 1 });

export class MembersPage extends Component {
  state = {
    page: 1,
  };

  static fetchData = ({ store, query, user }) => {
    if (!user || user.isBlocked) {
      return;
    }

    return store.dispatch(
      fetchMembers({
        pageSize: MEMBERS_PER_PAGE,
        page: 1,
        ..._.pick(query, ['sort', 'name']),
      })
    );
  };

  componentDidMount = () => {
    if (this.props.isAuthenticated && !this.props.isBlocked) {
      this.fetchMembers();
    }
  };

  componentDidUpdate = ({ sort, name, isAuthenticated }) => {
    if (
      this.props.sort !== sort ||
      this.props.name !== name ||
      (this.props.isAuthenticated && isAuthenticated !== this.props.isAuthenticated)
    ) {
      this.props.clearMembers();
      this.setState(reset, this.fetchMembers);
    }
  };

  fetchMembers = () => {
    const { page } = this.state;
    const { sort, name, fetchMembers } = this.props;

    fetchMembers({
      sort,
      name,
      page,
      pageSize: MEMBERS_PER_PAGE,
    });
  };

  handleLoad = () => this.setState(increment, this.fetchMembers);

  renderNoResults = () => {
    const { name, membersCount, isLoading, viewMode } = this.props;

    if (isLoading || membersCount) {
      return null;
    }

    return viewMode !== VIEW_MODE_SITE ? <MembersPlaceholder/> : <NoMemberResults name={name}/>;
  };

  renderList = () => {
    const { isLoading, members, membersCount } = this.props;
    return (
      (isLoading || membersCount > 0) &&
      <div>
        <MembersList members={members}/>
        <InfiniteListLoader
          onLoad={this.handleLoad}
          loader={<Loader/>}
          isLoading={isLoading}
          hasMore={members.length < membersCount}
        />
      </div>
    );
  };

  renderSignUp = () => {
    const { t } = this.props;
    return (
      <EmptyStates title={t('members-page.sign-up-title')} content={t('members-page.sign-up-content')}>
        <LoginButton/>
      </EmptyStates>
    );
  };

  render = () => {
    const { isLoading, isBlocked, members, isAuthenticated } = this.props;

    if (isBlocked) {
      return <AccountSuspended/>;
    }

    return (
      <Page noSpacing>
        <AnimatedLoader isLoading={isLoading && !members.length}>
          <DefaultDesktopLayout>
            {isAuthenticated && this.renderNoResults()}
            {isAuthenticated && this.renderList()}
            {!isAuthenticated && this.renderSignUp()}
          </DefaultDesktopLayout>
        </AnimatedLoader>
        <AppLoaded/>
      </Page>
    );
  };
}

MembersPage.propTypes = {
  clearMembers: PropTypes.func,
  fetchMembers: PropTypes.func,
  onFilterChange: PropTypes.func,
  sort: PropTypes.string,
  name: PropTypes.string,
  members: PropTypes.array,
  membersCount: PropTypes.number,
  isLoading: PropTypes.bool,
  isBlocked: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  t: PropTypes.func,
  viewMode: PropTypes.string,
};

const buildLocation = (location, params) => ({ ...location, query: { ...params } });

const mapStateToProps = (state, { location }) => ({
  sort: location.query.sort || 'postsCount',
  name: location.query.name || '',
  members: getMembers(state),
  membersCount: getMembersCount(state),
  isLoading: getIsMembersLoading(state),
  viewMode: getViewMode(state),
});

const mapDispatchToProps = (dispatch, { location }) =>
  bindActionCreators(
    {
      clearMembers,
      fetchMembers: fetchMembersWithFakeLoading,
      onFilterChange: params => replace(buildLocation(location, params)),
    },
    dispatch
  );

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps), withAuth, withTranslate)(MembersPage);



// WEBPACK FOOTER //
// ./app/containers/members-page/members-page.js